<template>
    <b-modal :id="`${id}-modal`" title="Drug Notes" hide-footer>
        <template v-if="entityId">
            <NotesList :entityId="entityId" :entityType="entityType" :pageSize="5"/>
        </template>
    </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import NotesList from "@/components/Note/NotesList.vue";
import { EntityType } from "@/models/EntityType";
import { DrugSource } from "@/models/Drug/DrugProduct";

@Component({
    name: "DrugNotesModalComponent",
    components: {
        NotesList,
    },
})
export default class DrugNotesModalComponent extends Vue {
    @Prop({ default: 'drug-notes' }) private id!: string;
    @Prop() private entityId!: number;
    @Prop({ default: () => DrugSource.GsddFederal }) private drugSource!: DrugSource;

    mounted() {
        document.addEventListener('keydown', this.preventDefaultForHotkeys);
        document.addEventListener('keyup', this.hotKeysListener);
    }

    beforeDestroy() {
        document.removeEventListener("keydown", this.preventDefaultForHotkeys);
        document.removeEventListener("keyup", this.hotKeysListener);
    }

    preventDefaultForHotkeys(e: KeyboardEvent) {
        if (e.ctrlKey && e.key === "m") e.preventDefault();
    }

    hotKeysListener(e: KeyboardEvent) {
        if (e.ctrlKey && e.key === "m") this.$bvModal.show(`${this.id}-modal`);
    }

    get entityType() {
        switch (this.drugSource) {
            case DrugSource.GsddFederal:
                return EntityType.GsddDrug;
            case DrugSource.NonGsddProduct:
                return EntityType.NonGsddDrug;
            case DrugSource.CompoundProduct:
                return EntityType.CompoundDrug;
        }
    }

    hideModal() {
        this.$bvModal.hide(`${this.id}-modal`);
    }
}

</script>

<style scoped>
</style>
